import { createSelector } from "@reduxjs/toolkit";
import { replyCommentSliceInitialState } from "app/components/ReplyComment/redux/initialState";
import type { RootState } from "types";

const domain = (state: RootState) =>
  state?.replyCommentState || replyCommentSliceInitialState;

// Mention Data --
export const selectMentionData = createSelector(
  [domain],
  (state) => state?.mentionData,
);
// --
